import React, { useRef, useEffect } from "react";

const mensSizes = Array.from({ length: 19 }, (_, i) =>
  (6 + i * 0.5).toFixed(1).replace(".0", "")
); // 6, 6.5, ..., 15

export const filterProductsBySize = (products, selectedSizes) => {
  if (!selectedSizes.length) return products;
  return products.filter((p) =>
    selectedSizes
      .map((s) => s.replace(/M$/, "")) // Remove 'M' suffix
      .includes(String(p.size))
  );
};

function SizeFilterModal({ show, onClose, onSelect, selected }) {
  const modalRef = useRef();

  useEffect(() => {
    if (!show) return;
    function handleClickOutside(event) {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [show, onClose]);

  if (!show) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div
        ref={modalRef}
        className="bg-white rounded-2xl shadow-xl p-6 w-full max-w-md relative"
      >
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-700 text-2xl font-bold focus:outline-none"
          aria-label="Close"
        >
          &times;
        </button>
        <h2 className="text-2xl font-bold mb-4 text-center">Select Sizes</h2>
        <div className="flex flex-wrap gap-2 justify-center mb-6">
          {mensSizes.map((size) => (
            <button
              key={size}
              onClick={() => {
                if (selected.includes(size)) {
                  onSelect(selected.filter((s) => s !== size));
                } else {
                  onSelect([...selected, size]);
                }
              }}
              className={`px-4 py-2 rounded-full border font-semibold ${
                selected.includes(size)
                  ? "bg-indigo-600 text-white border-indigo-600"
                  : "bg-gray-100 text-gray-800 border-gray-300 hover:bg-indigo-100"
              }`}
            >
              {size}M
            </button>
          ))}
        </div>
        <div className="flex justify-end">
          <button
            onClick={() => {
              onSelect([]);
            }}
            className="px-4 py-2 rounded bg-indigo-600 text-white font-semibold"
          >
            Clear Filter
          </button>
        </div>
      </div>
    </div>
  );
}

export default SizeFilterModal;